<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../Mixins/global'
import Scoring from './Scoring.vue'

export default {
  components: {
    Scoring,
    BlockContent,
  },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    entity: { type: Object, required: true },
    contracts: { type: Object, required: true },
    loading: { type: Boolean, required: true },
  },

  data() {
    return {
      iconCS: '',
      iconEli: '',
      scores: [],
      providers: [],
    }
  },

  methods: {
    sortScores() {
      this.scores = this.entity.scores.sort((a, b) => {
        return new Date(b.scoreAt) - new Date(a.scoreAt)
      })
    },
    arrayProvider() {
      let providers = []
      this.entity.scores.map((score) => {
        providers.push(score.provider)
      })

      this.providers = providers.sort().filter((item, pos, ary) => {
        return !pos || item != ary[pos - 1]
      })
    },
    scrollComment(scoreInfos) {
      let size = 0
      if (scoreInfos.creditsafe.comment) {
        size += scoreInfos.creditsafe.comment.length
      }

      if (scoreInfos.ellisphere.comment) {
        size += scoreInfos.ellisphere.comment.length
      }

      if (size > 300) {
        return 'scrollbar-y '
      }

      return ''
    },
    scoreShow() {
      this.sortScores()
      this.arrayProvider()
    },
  },
}
</script>
<template>
  <div>
    <div class="row">
      <div class="col">
        <h4 v-if="Object.keys(entity).length > 0">{{ $t('entity.information.sheet.data', { data: entity.name }) }}</h4>
        <h4 v-else>{{ $t('entity.information.sheet.title') }}</h4>
      </div>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-6">
          <BlockContent
            title-t="entity.information.exposition.title"
            :title-level="5"
            color="primary"
            inner-bloc-class="border-contract-yellow pb-3"
          >
            <div class="row">
              <div class="media media-single w-100 py-0">
                <span class="title text-dark">
                  <b>{{ $t('entity.information.exposition.outstanding') }}</b>
                </span>
                <span class="d-flex justify-content-between" style="flex: 4">
                  <span class="badge badge-pill fs-14 ml-1 badge-secondary" style="min-width: 10%">{{
                    entity.outstanding ? entity.outstanding.number : 0
                  }}</span>
                  <span class="badge badge-pill fs-14 ml-1 badge-secondary" style="min-width: 20%"
                    >{{
                      entity.outstanding
                        ? entity.outstanding.amount > 0
                          ? $n(Math.round(entity.outstanding.amount / 1000)) + ' K'
                          : 0
                        : 0
                    }}€</span
                  >
                </span>
              </div>
            </div>
            <div class="row">
              <div class="media media-single w-100 py-2">
                <span class="title text-dark">
                  <b>{{ $t('entity.information.exposition.demand') }}</b>
                </span>
                <span class="d-flex justify-content-between" style="flex: 4">
                  <span class="badge badge-pill fs-14 ml-1 badge-secondary" style="min-width: 10%">{{
                    entity.demandsExpo ? entity.demandsExpo.number : 0
                  }}</span>
                  <span class="badge badge-pill fs-14 ml-1 badge-secondary" style="min-width: 20%"
                    >{{
                      entity.demandsExpo
                        ? entity.demandsExpo.amount > 0
                          ? $n(Math.round(entity.demandsExpo.amount / 1000)) + ' K'
                          : 0
                        : 0
                    }}€</span
                  >
                </span>
              </div>
            </div>
          </BlockContent>
        </div>
        <div class="col-md-6">
          <BlockContent color="primary" inner-bloc-class="border-contract-yellow">
            <template #header>
              <h5 class="text-primary">
                {{ $t('entity.information.partner.title') }}
                <i :class="'fas fa-check-circle mr-2 ' + (entity.checkPlatform ? 'text-success' : 'text-danger')"></i>
              </h5>
            </template>
            <div class="row">
              <div class="col-sm">
                <span class="title text-dark"
                  ><b>{{ $t('entity.information.partner.companySalesman') }}</b></span
                >
              </div>
              <div class="col-sm">{{ entity.companySalesman ? entity.companySalesman.name : '' }}</div>
            </div>
          </BlockContent>
        </div>
      </div>
      <div class="row" v-if="scores">
        <div class="col">
          <BlockContent
            title-t="entity.information.score.title"
            :title-level="5"
            color="primary"
            inner-bloc-class="border-contract-yellow pb-3"
          >
            <Scoring
              v-for="provider in providers"
              :key="provider"
              :provider="provider"
              :scores="scores"
              :credit-limit="
                provider == 'Credit Safe' ? entity.creditLimitCS : provider == 'Ellisphere' ? entity.creditLimitEli : ''
              "
            />
          </BlockContent>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BlockContent inner-bloc-class="border-contract-yellow bloc-entity__presentation">
            <template #header-title>
              <div class="d-flex justify-content-between">
                <h5 class="text-primary" v-html="$t('entity.information.presentation.title')"></h5>
              </div>
            </template>
            <div class="row my-5">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.name') }}</b>
                  </div>
                  <div class="col-md-7">{{ entity.name }}</div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.address') }}</b>
                  </div>
                  <div class="col-md-7" v-html="entity.address ? entity.address.formattedHtml : ''"></div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.siren') }}</b>
                  </div>
                  <div class="col-md-7">{{ entity.siren }}</div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.rcs') }}</b>
                  </div>
                  <div class="col-md-7">{{ entity.rcs }}</div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.vatIntra') }}</b>
                  </div>
                  <div class="col-md-7">{{ entity.vatIntra }}</div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.createdAt') }}</b>
                  </div>
                  <div class="col-md-7">{{ setDate(entity.createdAt) }}</div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.fields.disputeType.label') }}</b>
                  </div>
                  <div class="col-md-7">{{ entity.disputeType ? entity.disputeType.name : '' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.capital') }}</b>
                  </div>
                  <div class="col-md-7">{{ $n(Number(entity.capital), 'currency') }}</div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.legalForm') }}</b>
                  </div>
                  <div class="col-md-7">{{ entity.legalForm }}</div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.activity') }}</b>
                  </div>
                  <div class="col-md-7">{{ entity.activityDesc }}</div>
                </div>
                <div class="row" style="margin-top: 2rem !important">
                  <div class="col-md-5">
                    <b>{{ $t('entity.information.presentation.workforce') }} </b>
                  </div>
                  <div class="col-md-7">{{ entity.workforce }}</div>
                </div>
              </div>
            </div>
          </BlockContent>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BlockContent
            title-t="entity.information.comments"
            :title-level="5"
            color="primary"
            inner-bloc-class="border-contract-yellow"
            :bloc-content-class="(entity.scoreInfos ? scrollComment(entity.scoreInfos) : '') + 'bloc-entity__comment'"
          >
            <div class="row">
              <div class="col-md-3">
                <b>{{ $t('entity.information.provider.cs') }}</b>
              </div>
              <div class="col-md-9">
                {{ entity.scoreInfos ? entity.scoreInfos.creditsafe.comment : '' }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <b>{{ $t('entity.information.provider.eli') }}</b>
              </div>
              <div class="col-md-9">
                {{ entity.scoreInfos ? entity.scoreInfos.ellisphere.comment : '' }}
              </div>
            </div>
          </BlockContent>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BlockContent
            v-if="scores && scores.length > 0"
            title-t="entity.information.scoreHistory"
            :title-level="5"
            color="primary"
            inner-bloc-class="border-contract-yellow"
            :bloc-content-class="(scores.length > 8 ? 'scrollbar-y' : '') + ' bloc-entity__bloc'"
          >
            <div v-for="score in scores">
              <div class="pb-2">
                {{
                  setDate(score.scoreAt) +
                  ' ' +
                  $t('entity.information.score.note') +
                  ' ' +
                  score.provider +
                  ' ' +
                  score.score +
                  (score.provider == 'Credit Safe' ? '/100' : '/10')
                }}
              </div>
            </div>
          </BlockContent>
          <BlockContent
            v-else
            title-t="entity.information.scoreHistory"
            :title-level="5"
            color="primary"
            inner-bloc-class="border-contract-yellow"
            bloc-content-class="bloc-entity__bloc"
          >
            <div class="text-center">
              {{ $t('entity.information.score.empty') }}
            </div>
          </BlockContent>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BlockContent
            title-t="entity.information.judgements.title"
            :title-level="5"
            color="primary"
            inner-bloc-class="border-contract-yellow"
          >
            <div class="row my-3">
              <div class="col-md-6">
                <b>{{ $t('entity.information.judgements.monitoredAt') }}</b>
              </div>
              <div class="col-md-6">
                {{ entity.monitoredAt ? setDate(entity.monitoredAt) : '' }}
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-6">
                <b>{{ $t('entity.information.judgements.nbJudgements') }}</b>
              </div>
              <div class="col-md-6">
                {{ entity.nbJudgements }}
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-6">
                <b>{{ $t('entity.information.judgements.judgementTotal') }}</b>
              </div>
              <div class="col-md-6">
                {{ entity.judgementTotal ? $n(Number(entity.judgementTotal)) : 0 }}
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-6">
                <b>{{ $t('entity.information.judgements.judgementDue') }}</b>
              </div>
              <div class="col-md-6">
                {{ entity.judgementDue ? $n(Number(entity.judgementDue)) : 0 }}
              </div>
            </div>
          </BlockContent>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BlockContent
            v-if="entity.financialEvents"
            title-t="entity.information.events.title"
            :title-level="5"
            color="primary"
            inner-bloc-class="border-contract-yellow"
            bloc-content-class="scrollbar-x-mobile"
          >
            <table class="table table-striped table-hover fs-16">
              <thead style="display: block">
                <tr style="display: flex">
                  <th class="font-weight-bold" style="width: 30%">{{ $t('entity.information.events.date') }}</th>
                  <th class="font-weight-bold" style="width: 30%">{{ $t('entity.information.events.code') }}</th>
                  <th class="font-weight-bold" style="width: 40%">{{ $t('entity.information.events.event') }}</th>
                </tr>
              </thead>

              <tbody
                v-if="entity && entity.financialEvents.length > 0"
                :class="(entity.financialEvents.length > 8 ? 'scrollbar-y ' : '') + 'bloc-entity__bloc'"
                style="display: block; overflow-y: scroll"
              >
                <tr v-for="event in entity.financialEvents" style="display: flex">
                  <td style="width: 30%">{{ event.date ? setDate(event.date, 'datetime_short') : '' }}</td>
                  <td style="width: 30%">{{ event.code }}</td>
                  <td style="width: 40%">{{ event.text }}</td>
                </tr>
              </tbody>
              <tbody v-else class="text-center my-3">
                <tr>
                  <td>{{ $t('entity.information.events.empty') }}</td>
                </tr>
              </tbody>
            </table>
          </BlockContent>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
